<template>
    <div class="row">

        <div class="col-12">
            <article class="product">
                <div class="row">
                    <div class="col-lg-4 col-md-6 col-sm-12">
                        <div class="product-gallery relative-galery default">
                            <img class="zoom-img" id="img-product-zoom" :src="productInfo.PicPath" :data-zoom-image="productInfo.PicPath" width="411" @error="imageLoadOnError" :title="productInfo.Name.replace(/\s+/g, '-')" :alt="productInfo.ShortName.replace(/\s+/g, '-') +' ' +  productInfo.Name.replace(/\s+/g, '-')" />
                            <div id="gallery_01f" style="width:500px;float:left;">

                                <div class="owl-carousel">
                                    <div class="item">
                                        <a href="#" :title="productInfo.Name" class="elevatezoom-gallery" data-update="" :data-image="productInfo.PicPath" :data-zoom-image="productInfo.PicPath">
                                            <img :src="productInfo.PicPath" width="100" @error="imageLoadOnError" :title="productInfo.Name.replace(/\s+/g, '-')" :alt="productInfo.ShortName.replace(/\s+/g, '-') +' ' +  productInfo.Name.replace(/\s+/g, '-')" />
                                        </a>
                                    </div>
                                    <div class="item" v-if="productInfo.ProductPics != null" v-for="(pic,index) in productInfo.ProductPics">
                                        <a href="#" :title="productInfo.Name" :class="['elevatezoom-gallery',(index == 0)? 'active' : '']" data-update="" :data-image="pic.FilePath" :data-zoom-image="pic.FilePath">
                                            <img :src="pic.FilePath" width="100" @error="imageLoadOnError" :title="productInfo.Name.replace(/\s+/g, '-')" :alt="productInfo.ShortName.replace(/\s+/g, '-') +' ' +  productInfo.Name.replace(/\s+/g, '-')" />
                                        </a>
                                    </div>

                                </div>
                            </div>
                        </div>
                        <ul class="gallery-options">
                            <li>
                                <router-link title="مقایسه محصول" tag="button" :to="{ name: 'compareProduct' , query: { productId: productInfo.Id, SubGroupId: productInfo.SubGroupId } }" class="add-favorites">
                                    <!--<img style="width:32px;" src="/assets/img/Compare-256.svg" />-->
                                    <i class="fa fa-toggle-on"></i>
                                </router-link>
                                <span class="tooltip-option">مقایسه محصول</span>
                            </li>
                            <li>
                                <button data-toggle="modal" data-target="#productShare"><i class="fa fa-share-alt"></i></button>
                                <span class="tooltip-option">اشتراک گذاری</span>
                            </li>
                            <li>
                                <button @click="openChangesPriceProduct"><i class="fa fa-bar-chart"></i></button>
                                <span class="tooltip-option">تغییرات قیمت</span>
                            </li>
                        </ul>
                        <!-- Modal Core productShare-->
                        <div class="modal-share modal fade" id="productShare" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true">
                            <div class="modal-dialog">
                                <div class="modal-content">
                                    <div class="modal-header">
                                        <button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button>
                                        <h4 class="modal-title" id="myModalLabel">اشتراک گذاری</h4>
                                    </div>
                                    <div class="modal-body">
                                        <div class="form-share">
                                            <div class="form-share-title">اشتراک گذاری در شبکه های اجتماعی</div>
                                            <div class="row">
                                                <div class="col-12">
                                                    <ul class="btn-group-share">
                                                        <li>
                                                            <a :href="'https://wa.me/?text=' +  linkProduct" class="btn-share btn-share-whatsap" target="_blank">
                                                                <i class="fa fa-whatsapp"></i>
                                                            </a>
                                                        </li>
                                                        <li>
                                                            <a :href="'https://t.me/' + linkProduct" class="btn-share btn-share-facebook" target="_blank">
                                                                <i class="fa fa-telegram"></i>
                                                            </a>
                                                        </li>

                                                    </ul>
                                                </div>

                                            </div>
                                            <div class="row">
                                                <div class="col-12">
                                                    <hr />
                                                </div>
                                            </div>
                                            <div class="row">
                                                <div class="col-12">
                                                    <div class="form-share-title">لینک محصول</div>
                                                    <input id="texturlproduct" class="textlinkpage" :value="linkProduct">
                                                    <button @click="copylinkPage()" class="btn-primary linkpagecopyBtn">کپی لینک </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- Modal Core productShare-->
                        <!-- Modal Core ChangesPriceProduct-->

                        <changePrices-component :ProductSaleParams="productInfo.ProductSaleParams"></changePrices-component>

                        <!-- Modal Core ChangesPriceProduct-->
                    </div>
                    <div :class="productPropertyValueList.length > 0 ? 'col-lg-4 col-md-6 col-sm-12' : 'col-lg-8 col-md-6 col-sm-12'">
                        <div class="row">
                            <div class="product-title default">
                                <h1>
                                    {{productInfo.Name}}
                                    <span>{{productInfo.ShortName}}</span>
                                </h1>
                            </div>
                            <div style="margin-top:15px" class="product-directory default">
                                <ul>

                                    <li v-if="productInfo.Code != '' && productInfo.Code != null">
                                        <span>کد کالا</span> :
                                        <span class="btn-link-border">
                                            {{productInfo.Code}}
                                        </span>

                                    </li>
                                    <li v-if="productInfo.BrandId > 0">
                                        <span>برند</span> :
                                        <router-link target="_blank" :to="{ path: '/filter', query: { BrandCode: productInfo.BrandId , BrandName: productInfo.BrandTitle }}" :title="productInfo.BrandTitle" class="btn-link-border" v-text="">
                                            {{productInfo.BrandTitle}}
                                        </router-link>
                                        <!--<span class="product-brand-title">{{productInfo.BrandTitle}}</span>-->
                                    </li>
                                </ul>
                            </div>
                            <div v-if="productInfo.ProductTags.length > 0" class="product-guarantee tages-generate default">

                                <span>برچسب</span> :
                                <ul>
                                    <li v-for="ProductTags in productInfo.ProductTags">
                                        <router-link :to="{ name: 'filter' , query: { TagId: ProductTags.Id , TagName: ProductTags.Title.replace(/\s+/g, '-') }}">{{ ProductTags.Title }}</router-link>
                                    </li>
                                </ul>
                            </div>
                            <div v-show="isShowAttributeSelector" class="product-variants default" v-if="saleParam != null">
                                <span> انتخاب کنید: </span>
                                <div class="form-account-row">
                                    <select class="input-field input-field-size-color" v-model="saleParam" @change="setSaleParam(saleParam)">
                                        <option v-for="productSaleParam in productInfo.ProductSaleParams" :value="productSaleParam">{{productSaleParam.Name == '' ? '---------' : productSaleParam.Name}}</option>
                                    </select>
                                </div>
                            </div>
                            <div class="product-directory default">
                                <ul>
                                    <li>
                                        <span>‌گروه </span> :
                                        <span class="product-brand-title">{{productInfo.GroupTitle}}</span>
                                    </li>
                                    <li>
                                        <span>زیر گروه</span> :
                                        <router-link target="_blank" :to="{ path: '/filter', query: { SubGroupId: productInfo.SubGroupId , SubGroupName: productInfo.SubGroupTitle }}" :title="productInfo.SubGroupTitle" class="btn-link-border" v-text="">
                                            {{productInfo.SubGroupTitle}}
                                        </router-link>
                                    </li>

                                </ul>
                            </div>
                            <div class="product-guarantee default" v-if="productInfo.GuaranteeDescription != null && productInfo.GuaranteeDescription != '' ">
                                <i class="fa fa-check-circle"></i>
                                <p class="product-guarantee-text">{{productInfo.GuaranteeDescription}}</p>
                            </div>
                            <div v-if="productInfo.IsPossibilityBuyProduct" class="price-product defualt col-12">
                                <div v-if="!isUserLogined && productInfo.IsShowPriceInWeb" class="row">
                                    <div v-if="stockInventory != 0" class="col-12">
                                        <div> <span class="price-main-title">قیمت :</span></div>
                                        <div v-if="productInfo.Price != 0" :class="[(productInfo.DiscountPercent == 0) ? 'price-main-at':'price-main']">
                                            <div class="price-value">
                                                <span v-if="productInfo.DiscountPercent == 0"> {{(productInfo.Price + paddingPrice) | formatNumber }}</span>
                                                <span class="discount" v-if="productInfo.DiscountPercent > 0">
                                                    {{((productInfo.Price + paddingPrice ) - (((productInfo.Price + paddingPrice) * productInfo.DiscountPercent)/100))  | formatNumber  }}
                                                    <span class="discountvalue" v-if="productInfo.DiscountPercent > 0">   {{(productInfo.Price + paddingPrice) | formatNumber}}  <span class="discountvalue-t"> تومان </span></span>

                                                </span>
                                                <span class="price-currency"> تومان </span>
                                            </div>
                                            <div v-if="productInfo.DiscountPercent != 0" class="price-discount" data-title="تخفیف">
                                                <span>
                                                    {{productInfo.DiscountPercent}}
                                                </span>
                                                <span>%</span>
                                            </div>
                                        </div>
                                        <div v-else class="callToMain">
                                            <span class="call">جهت استعلام قیمت تماس بگیرید</span>
                                        </div>
                                    </div>
                                </div>

                                <div v-if="isUserLogined && customerGroupId != 2 " class="row">
                                    <div v-if="stockInventory != 0" class="col-12">
                                        <div> <span class="price-main-title">قیمت :</span></div>
                                        <div v-if="productInfo.Price != 0" :class="[(productInfo.DiscountPercent == 0) ? 'price-main-at':'price-main']">
                                            <div class="price-value">
                                                <span v-if="productInfo.DiscountPercent == 0"> {{(productInfo.Price + paddingPrice) | formatNumber }}</span>
                                                <span class="discount" v-if="productInfo.DiscountPercent > 0">
                                                    {{((productInfo.Price + paddingPrice ) - (((productInfo.Price + paddingPrice) * productInfo.DiscountPercent)/100))  | formatNumber  }}
                                                    <span class="discountvalue" v-if="productInfo.DiscountPercent > 0">   {{(productInfo.Price + paddingPrice) | formatNumber}}  <span class="discountvalue-t"> تومان </span></span>

                                                </span>
                                                <span class="price-currency"> تومان </span>
                                            </div>
                                            <div v-if="productInfo.DiscountPercent != 0" class="price-discount" data-title="تخفیف">
                                                <span>
                                                    {{productInfo.DiscountPercent}}
                                                </span>
                                                <span>%</span>
                                            </div>
                                        </div>
                                        <div v-else class="callToMain">
                                            <span class="call">جهت استعلام قیمت تماس بگیرید</span>
                                        </div>
                                    </div>
                                </div>

                                <div v-if="isUserLogined && customerGroupId == 2" class="row">
                                    <div v-if="stockInventory != 0" class="col-12">
                                        <div> <span class="price-main-title">قیمت نقدی :</span></div>
                                        <div v-if="productInfo.Price != 0" :class="[(productInfo.DiscountPercent == 0) ? 'price-main-at':'price-main']">
                                            <div class="price-value">
                                                <span v-if="productInfo.DiscountPercent == 0"> {{(productInfo.Price + paddingPrice) | formatNumber }}</span>
                                                <span class="discount" v-if="productInfo.DiscountPercent > 0">
                                                    {{((productInfo.Price + paddingPrice ) - (((productInfo.Price + paddingPrice) * productInfo.DiscountPercent)/100))  | formatNumber  }}
                                                    <span class="discountvalue" v-if="productInfo.DiscountPercent > 0">   {{(productInfo.Price + paddingPrice) | formatNumber}}  <span class="discountvalue-t"> تومان </span></span>

                                                </span>
                                                <span class="price-currency"> تومان </span>
                                            </div>
                                            <div v-if="productInfo.DiscountPercent != 0" class="price-discount" data-title="تخفیف">
                                                <span>
                                                    {{productInfo.DiscountPercent}}
                                                </span>
                                                <span>%</span>
                                            </div>
                                        </div>
                                        <div v-else class="callToMain">
                                            <span class="call">جهت استعلام قیمت تماس بگیرید</span>
                                        </div>
                                    </div>
                                    <div v-if="stockInventory != 0"  class="col-12">
                                        <div> <span class="price-main-title">قیمت چکی :</span></div>
                                        <div v-if="productInfo.ColleagueChequePrice != 0" :class="[(productInfo.DiscountPercent == 0) ? 'price-main-at':'price-main']">
                                            <div class="price-value">
                                                <span v-if="productInfo.DiscountPercent == 0"> {{(productInfo.ColleagueChequePrice + paddingPrice) | formatNumber }}</span>
                                                <span class="discount" v-if="productInfo.DiscountPercent > 0">
                                                    {{((productInfo.ColleagueChequePrice + paddingPrice ) - (((productInfo.ColleagueChequePrice + paddingPrice) * productInfo.DiscountPercent)/100))  | formatNumber  }}
                                                    <span class="discountvalue" v-if="productInfo.DiscountPercent > 0">   {{(productInfo.ColleagueChequePrice + paddingPrice) | formatNumber}}  <span class="discountvalue-t"> تومان </span></span>

                                                </span>
                                                <span class="price-currency"> تومان </span>
                                            </div>
                                            <div v-if="productInfo.DiscountPercent != 0" class="price-discount" data-title="تخفیف">
                                                <span>
                                                    {{productInfo.DiscountPercent}}
                                                </span>
                                                <span>%</span>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>

                            <div v-if="!isUserLogined && productInfo.IsShowPriceInWeb && productInfo.IsPossibilityBuyProduct">
                                <div v-if="saleParam != null && stockInventory != 0 && productInfo.Price != 0" class="col-12 product-add-cart">
                                    <div class="addtocart">
                                        <a @click="addToCart(saleParam.Id)" class="dk-btn dk-btn-info">
                                            افزودن به سبد خرید
                                            <i class="now-ui-icons shopping_cart-simple"></i>
                                        </a>
                                        <div id="showloaderbtnaddcart" class="show-lo">
                                            <div class="div-loader">
                                                <img src="/assets/img/loader/loader.svg" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div v-else class="col-12 product-add default">
                                    <div class="parent-btn" v-if="productInfo.Price != 0">
                                        <h4 class="parent-btn" v-if="productInfo.Price != 0">
                                            محصول ناموجود
                                        </h4>
                                        <button v-if="EnableProductAvailabilityAlertInPage" @click="EnableProductAvailabilityAlert(productInfo.Id)"
                                                class="dk-btn dk-btn-danger">
                                            حذف اطلاع رسانی موجودی محصول
                                            <i class="fa fa-bell"></i>
                                        </button>
                                        <button v-if="!EnableProductAvailabilityAlertInPage" @click="EnableProductAvailabilityAlert(productInfo.Id)"
                                                class="dk-btn dk-btn-danger">
                                            موجود شد به من اطلاع بده
                                            <i class="fa fa-bell"></i>
                                        </button>
                                    </div>
                                </div>
                            </div>

                            <div v-if="isUserLogined && customerGroupId != 2 && productInfo.IsPossibilityBuyProduct">
                                <div v-if="saleParam != null && stockInventory != 0 && productInfo.Price != 0" class="col-12 product-add-cart">
                                    <div class="addtocart">
                                        <a @click="addToCart(saleParam.Id)" class="dk-btn dk-btn-info">
                                            افزودن به سبد خرید
                                            <i class="now-ui-icons shopping_cart-simple"></i>
                                        </a>
                                        <div id="showloaderbtnaddcart" class="show-lo">
                                            <div class="div-loader">
                                                <img src="/assets/img/loader/loader.svg" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div v-else class="col-12 product-add default">
                                    <div class="parent-btn" v-if="productInfo.Price != 0">
                                        <h4 class="parent-btn" v-if="productInfo.Price != 0">
                                            محصول ناموجود
                                        </h4>
                                        <button v-if="EnableProductAvailabilityAlertInPage" @click="EnableProductAvailabilityAlert(productInfo.Id)"
                                                class="dk-btn dk-btn-danger">
                                            حذف اطلاع رسانی موجودی محصول
                                            <i class="fa fa-bell"></i>
                                        </button>
                                        <button v-if="!EnableProductAvailabilityAlertInPage" @click="EnableProductAvailabilityAlert(productInfo.Id)"
                                                class="dk-btn dk-btn-danger">
                                            موجود شد به من اطلاع بده
                                            <i class="fa fa-bell"></i>
                                        </button>
                                    </div>
                                </div>
                            </div>

                            <div v-if="isUserLogined && customerGroupId == 2 && productInfo.IsPossibilityBuyProduct">
                                <div v-if="saleParam != null && stockInventory != 0 && productInfo.Price != 0" class="col-12 product-add-cart">
                                    <div class="addtocart">
                                        <a @click="addToCart(saleParam.Id)" class="dk-btn dk-btn-info">
                                            افزودن به سبد خرید
                                            <i class="now-ui-icons shopping_cart-simple"></i>
                                        </a>
                                        <div id="showloaderbtnaddcart" class="show-lo">
                                            <div class="div-loader">
                                                <img src="/assets/img/loader/loader.svg" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div v-else class="col-12 product-add default">
                                    <div class="parent-btn" v-if="productInfo.Price != 0">
                                        <!--<h4 class="parent-btn" v-if="productInfo.Price != 0">
                                        محصول ناموجود
                                    </h4>-->
                                        <button v-if="EnableProductAvailabilityAlertInPage" @click="EnableProductAvailabilityAlert(productInfo.Id)"
                                                class="dk-btn dk-btn-danger">
                                            حذف اطلاع رسانی موجودی محصول
                                            <i class="fa fa-bell"></i>
                                        </button>
                                        <button v-if="!EnableProductAvailabilityAlertInPage" @click="EnableProductAvailabilityAlert(productInfo.Id)"
                                                class="dk-btn dk-btn-danger">
                                            موجود شد به من اطلاع بده
                                            <i class="fa fa-bell"></i>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>



                    <div v-if="productPropertyValueList.length  > 0" class="col-lg-4 col-md-6 col-sm-12 center-breakpoint">
                        <div class="product-params default">
                            <ul data-title=" ‌محصولات موجود">
                                <li></li>
                                <li v-for="Highlighted in  productPropertyValueList">
                                    <h3 style="font-size:13px;">{{Highlighted.PropertyTitle}} : {{Highlighted.PropertyValue == null || Highlighted.PropertyValue == '' ?  '----' : Highlighted.PropertyValue }}</h3>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </article>
        </div>
        <enable-product-availability-alert-modal></enable-product-availability-alert-modal>
    </div>
</template>
<script type="text/javascript">

</script>
<script>
    import { setCart } from "../../module/cart";
    import changePrices from "./changePrices.vue"
    import { httpPromise } from "../../module/httpUtility";
    import EnableProductAvailabilityAlertModal from "./EnableProductAvailabilityAlertModal.vue";

    export default {
        props: {
            productInfo: {
                type: Object,
            },
        },
        components: {
            'changePrices-component': changePrices,
            'enable-product-availability-alert-modal': EnableProductAvailabilityAlertModal
        },
        data() {
            return {
                saleParam: null,
                stockInventory: 0,
                isShowAttributeSelector: true,
                paddingPrice: 0,
                linkProduct: '#',
                productPropertyList: [],
                productPropertyValueList: [],
                EnableProductAvailabilityAlertText: "",
                EnableProductAvailabilityAlertInPage: false
            }
        },
        mounted() {
            this.EnableProductAvailabilityAlertText = this.productInfo.EnableProductAvailabilityAlert ? 'دیگر به من اطلاع نده !' : 'موجود شد به من اطلاع بده !';
            this.EnableProductAvailabilityAlertInPage = this.productInfo.EnableProductAvailabilityAlert;
        },
        computed: {
            customerGroupId: function () {
                return this.$store.getters.readCustomerGroupId;
            },
            cart: function () {
                return this.$store.getters.readCart;
            }
        },
        methods: {
            openChangesPriceProduct() {
                $(function () {
                    $('#changesPriceProduct').modal({ backdrop: 'static', keyboard: false });
                    $('#changesPriceProduct').modal('show');
                });
            },
            copylinkPage() {
                var copyText = document.querySelector("#texturlproduct");
                copyText.select();
                document.execCommand("copy");
                $(function () {
                    var $temp = $("<input id='A' type='text' value='#' />".replace(/#/g, $('.textlinkpage').text()));
                    $("body").append($temp);
                    $('.linkpagecopyBtn').addClass('copied');
                    $('.linkpagecopyBtn').html('کپی شد');
                    setTimeout(function () {
                        $('.linkpagecopyBtn').removeClass('copied');
                        $('.linkpagecopyBtn').html('کپی لینک')
                    }, 2000)
                });

            },
            setSaleParam(saleParam) {
                this.paddingPrice = saleParam.PaddingPrice;
                this.stockInventory = saleParam.StockInventory;
            },
            addToCart(productSaleParamId) {
                setCart(this, productSaleParamId, "Increase", '#showloaderbtnaddcart');
            },
            imageLoadOnError(event) {
                event.target.src = "/assets/img/no-image-available.png";
            },
            //Increase(productId) {
            //    setCart(this, productId, 'Increase', '.loader');
            //},
            //Decrease(productId) {
            //    setCart(this, productId, 'Decrease', '.loader');
            //},
            filterBySubGroup(id, name) {
                this.$router.push({ name: 'filter', query: { SubGroupId: id, SubGroupName: name } });
                this.isShowSearchResult = false;
            },
            EnableProductAvailabilityAlert(id) {

                if (!this.EnableProductAvailabilityAlertInPage) {
                    $(function () {
                        this.EnableProductAvailabilityAlertInPage = true;
                        $('#EnableProductAvailabilityAlert').modal({ backdrop: 'static', keyboard: false });
                        $('#EnableProductAvailabilityAlert').modal('show');
                    });
                } else {

                    httpPromise(this, '/v1/ProductManagement/CustomerProductAvailability/Delete', 'post', { CustomerMobNo: String(this.$store.getters.readUserMobNo), productId: window.location.href.split("/")[4] },
                        response => {
                            toastr.remove();
                            toastr.error("پیغام این محصول برای شما حذف شد");
                            this.EnableProductAvailabilityAlertText = 'موجود شد به من اطلاع بده !';
                            this.EnableProductAvailabilityAlertInPage = false;
                            this.isShowLoader = false;
                            this.TelNumber = "";
                            $(function () {
                                this.EnableProductAvailabilityAlertInPage = false;
                                $('#EnableProductAvailabilityAlert').modal('hide');
                            });

                        },
                        response => {
                            toastr.remove();
                            toastr.error(response.data.Message);
                            this.isShowLoader = false;
                        });


                }
            },
        },
        beforeMount: function () {
            for (var i = 0; i < this.productInfo.ProductPropertyGroups.length; i++) {
                this.productPropertyList.push(this.productInfo.ProductPropertyGroups[i].ProductPropertyValue);
            }
            for (var j = 0; j < this.productPropertyList.length; j++) {
                for (var a = 0; a < this.productPropertyList[j].length; a++) {
                    if (this.productPropertyList[j][a].PropertyValue == "✅") {
                        this.productPropertyValueList.push(this.productPropertyList[j][a]);
                    }
                }
            }
            console.log(this.productPropertyValueList)


            this.linkProduct = window.location.href;
            this.saleParam = this.productInfo.ProductSaleParams == null ? null : this.productInfo.ProductSaleParams[0];
            this.stockInventory = this.saleParam == null ? 0 : this.saleParam.StockInventory;
            this.paddingPrice = this.saleParam == null ? 0 : this.saleParam.PaddingPrice;
            if (this.productInfo.ProductSaleParams != null && this.productInfo.ProductSaleParams.length == 1 && this.saleParam.HasAttributes == false) {
                this.isShowAttributeSelector = false;
            }
            initializeChart();
            this.isUserLogined = IsNullOrEmptyString(localStorage.getItem('accessToken')) ? false : true;
        },
        beforeDestroy() {
            $(function () {
                $('#img-product-zoom-ZoomContainer').remove();
            });

        },
    }
</script>



<style scoped>

    .textlinkpage {
        display: block;
        width: 100%;
        margin-bottom: 20px;
        margin-top: 15px;
    }

    .btn-share-whatsap {
        background: #1bd741;
        border: 1px solid #1bd741;
    }

    .count-Item {
        background-color: #fff;
        width: 50px;
        height: 25px;
        font-size: 18px;
        font-size: 1.286rem;
        line-height: 28px;
        vertical-align: middle;
        letter-spacing: -.3px;
        text-align: center;
        color: #00bfd6;
        border-radius: 100%;
        display: inline-block;
        margin-right: 5px;
        margin-left: 7px;
    }

    .td-cart-box-counter {
        margin-top: 30px;
    }

        .td-cart-box-counter .cart-box-counter {
            text-align: center;
            position: relative;
        }

            .td-cart-box-counter .cart-box-counter .incress {
                position: absolute;
                font-size: 18px;
                vertical-align: top;
                display: inline-block;
                color: #fff;
                cursor: pointer;
                background-color: #aae67c;
                padding: 5px;
                border-radius: 5px;
                width: 30px;
                height: 30px;
                display: flex;
                justify-content: center;
                align-items: center;
                top: 0px;
                right: 10%;
            }

            .td-cart-box-counter .cart-box-counter .decress {
                position: absolute;
                font-size: 18px;
                vertical-align: top;
                display: inline-block;
                color: #fff;
                cursor: pointer;
                background-color: #e38686;
                padding: 5px;
                border-radius: 5px;
                width: 30px;
                height: 30px;
                display: flex;
                justify-content: center;
                align-items: center;
                top: 0px;
                left: 10%;
            }

        .td-cart-box-counter::before {
            font-size: 15px;
            bottom: 10px;
            width: 25px;
            height: 25px;
        }

        .td-cart-box-counter::after {
            font-size: 15px;
            top: 16px;
            width: 25px;
            height: 25px;
        }

    .product-title h1 {
        margin-bottom: 0;
    }

    .disadledbtn {
        padding: 15px 50px;
    }

    .input-field-size-color {
        padding: 7px 11px 7px 11px;
        width: 56%;
        letter-spacing: unset;
        font-family: iranyekan;
    }

    .price-main-title {
        font-weight: bold;
    }

    .price-main {
        padding: 20px 95px 0 0;
    }

    .price-main-at {
        padding: 0px 95px 0 0;
    }

    .display-in-bl {
        display: inline-block;
    }

    .discountvalue-t {
        position: absolute;
        left: -50px;
    }

    .show-lo {
        display: none;
    }

    .product-add-cart {
        margin-top: 35px;
    }

    .addtocart {
        display: inline-block;
        position: relative
    }

    .div-loader {
        bottom: 6px;
    }


    a.dk-btn, a.dk-btn:hover {
        color: #fff;
    }

    a.dk-btn {
        margin-top: 0;
        overflow: hidden;
        padding: 15px 50px;
    }

    .discount {
        display: inline-block;
        position: relative;
        font-size: 18px;
    }

        .discount::after {
            content: "";
            width: 100%;
            position: absolute;
            left: 0px;
            border-top: 1px solid #c6c6c6;
            -webkit-transform: rotate(-30deg);
            transform: rotate(0deg);
            top: -1px;
        }

    .discountvalue {
        position: absolute;
        top: -19px;
        right: 1px;
        font-size: 16px;
        color: #c6c6c6;
    }

    .tages-generate ul li a {
        background-color: #ccc;
        padding: 0 10px 2px 11px;
        color: #fff;
        border-radius: 8px;
        transition: all .3s;
        font-size: 13px;
    }

    .tages-generate ul li {
        float: right;
        margin-right: 10px;
        margin-top: 10px;
    }

    .tages-generate ul {
        margin-top: 6px;
    }

        .tages-generate ul li:hover a {
            transition: all .3s;
            color: #777;
        }

    @media only screen and (min-width: 0px) and (max-width: 640px) {
        .discount {
            font-size: 16px;
        }

        .discountvalue {
            font-size: 15px;
        }

        .price-main {
            padding: 10px 90px 0 0;
        }
    }
</style>